import { createAction, handleActions, Action } from 'redux-actions';
import { AVAILABLE_LOCALES } from '../config/constants';

export const ACTION_TYPES = {
    SET_LOCALE: 'locale/SET_LOCALE',
};

const initialState = {
    lang: 'uk',
};

// eslint-disable-next-line no-undef
export type ILocaleState = Readonly<typeof initialState>;

export const setLocale = createAction(ACTION_TYPES.SET_LOCALE);

export default handleActions(
    {
        [ACTION_TYPES.SET_LOCALE]: (state: ILocaleState, action: Action<string>): ILocaleState => ({
            ...state,
            lang: Object.values(AVAILABLE_LOCALES).includes(action.payload) ? action.payload : AVAILABLE_LOCALES.UK,
        }),
    },
    initialState,
);
